export default __webpack_public_path__ + "static/media/9.2.dd45fd9c.jpg";